import type { PolygonConstraint } from '@sembo-private/constraint-builder';

import type { ActivityProductType } from '@libs/trip-planner-interfaces';
import {
  IngredientType,
  AccommodationType,
} from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';
import type { ActivityIngredient } from './activityIngredient';

export interface OwnStayIngredientFilters {
  selectedActivityTypes: ActivityProductType[];
  activitiesFilterText: string;
}

export class OwnStayIngredient extends BaseIngredient<IngredientType.OwnStay> {
  public static get defaultFilters(): OwnStayIngredientFilters {
    return {
      selectedActivityTypes: [],
      activitiesFilterText: '',
    };
  }

  public searchText: string;
  public displayText: string;

  public polygonConstraint?: PolygonConstraint;

  public numberOfNights?: number;

  public subIngredients: ActivityIngredient[] = [];

  public userIsTyping = false;

  public filters: OwnStayIngredientFilters = OwnStayIngredient.defaultFilters;

  constructor(searchText: string, displayText?: string) {
    super(IngredientType.OwnStay);

    this.searchText = searchText;
    this.displayText = displayText ?? searchText;
  }

  public isIngredientCorrect(): boolean {
    return true;
  }

  public getSelectedActivityTypes(): ActivityProductType[] {
    let selectedActivityTypes = this.filters.selectedActivityTypes;

    if (selectedActivityTypes.length === 0) {
      selectedActivityTypes = [
        AccommodationType.Golf,
        AccommodationType.Ticket,
      ];
    }

    return selectedActivityTypes;
  }

  public resetAllFilters(): void {
    this.filters = OwnStayIngredient.defaultFilters;
  }
}
